export const DEFAULT_MAP_CENTER: [number, number] = [31.1471, 75.3412]; // Punjab, India
export const DEFAULT_MAP_ZOOM = 6;

export const ROUTE_COLORS = [
  '#2563eb', // blue-600
  '#dc2626', // red-600
  '#16a34a', // green-600
  '#9333ea', // purple-600
  '#ea580c', // orange-600
  '#0891b2', // cyan-600
  '#ca8a04', // yellow-600
  '#e11d48', // rose-600
];

export const PROGRAM_OPTIONS = [
  { value: 'TBTP', label: 'The Billion Tree Project' },
  { value: 'WM', label: 'Waste Management' },
  { value: 'WE', label: 'Women Equity' },
  { value: 'LL', label: 'Learn Labs' },
  { value: 'RGSH', label: 'RGS Hockey' },
  { value: 'SD', label: 'Sports for Development' },
  { value: 'RF', label: 'Regenerative Agriculture' },
];

export const PLAYBACK_SPEEDS = [1, 2, 4, 10];

export const TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
